import { z } from 'zod';
import { FOLDER_KINDS } from '../enums.js';
import { nonEmptyString, uuidSchema } from './common.js';
export const MAX_FOLDER_DEPTH = 5;
/**
 * Every project starts with one folder per kind, because a test case, a
 * checklist and a run always belong to one. They are ordinary folders: each
 * can be renamed, moved or deleted.
 */
export const DEFAULT_FOLDER_NAME = 'General';
export const folderKindSchema = z.enum(FOLDER_KINDS);
/**
 * Which tree a request is about. Defaults to test cases: they were the only
 * kind of content with folders before checklists got their own tree.
 */
export const folderTreeQuerySchema = z.object({
    kind: folderKindSchema.default('case'),
});
export const createFolderSchema = z.object({
    name: nonEmptyString(120, 'Name'),
    parentId: uuidSchema.nullable().optional(),
    /** A folder's kind is fixed at creation; a parent must share it. */
    kind: folderKindSchema.default('case'),
});
export const updateFolderSchema = z
    .object({
    name: nonEmptyString(120, 'Name').optional(),
    parentId: uuidSchema.nullable().optional(),
    position: z.number().int().min(0).optional(),
})
    .refine((value) => Object.keys(value).length > 0, { message: 'Nothing to update' });
export const deleteFolderSchema = z.object({
    /**
     * `move` keeps the folder's contents and puts them into `targetFolderId`,
     * `cascade` soft-deletes the folder subtree together with them. A target is
     * required for `move` whenever the subtree holds anything — its contents
     * cannot be left without a folder. Runs are history and are never deleted
     * with their folder, so `cascade` is refused for that tree.
     */
    strategy: z.enum(['move', 'cascade']).default('move'),
    targetFolderId: uuidSchema.optional(),
});
//# sourceMappingURL=folder.js.map